const OVERLAY_CLASSNAME = 'fixed top-0 left-0 right-0 bottom-0 z-50';
export default OVERLAY_CLASSNAME;
